<template>
        <div class="equity-common">
            <div class="equity-common-top" >
                <img :src="banner" class="equity-banner" alt />
                <a href="javascript:;" @click="goBack" class="go-back equity-back"></a>
                <a :href="applyUrl" class="apply-equity" ></a>                
            </div>
        </div>
</template>

<script>
export default {
    props: {
        applyUrl: String,
        banner: String,
        applyPayment:String,
        id:String
    },
    methods:{
        goBack(){
            this.$router.back()
        }
    }
};
</script>

<style lang="scss" scoped>
</style>